import { Routes } from '@angular/router';
import { marker as extractTranslation } from '@colsen1991/ngx-translate-extract-marker';
import { AppRoleKey } from '@nk/data-entities-lib';
import { SCREENING_CASE_REVIEW_ROUTE } from '../utils/screening-case-review.utils';

export const PERSON_SCREENING_ROUTES: Routes = [
  {
    path: '',
    loadComponent: () =>
      import('../components/person-screening/person-screening.component').then((m) => m.PersonScreeningComponent),
    data: {
      title: extractTranslation('tabs.person.screening') as string,
      faicon: 'binoculars',
      feature: 'screening',
      roles: [AppRoleKey.aml],
    },
  },
  {
    path: SCREENING_CASE_REVIEW_ROUTE,
    loadComponent: () =>
      import('../components/screening-case-review/screening-case-review.component').then(
        (m) => m.ScreeningCaseReviewComponent,
      ),
    data: {
      noTab: true,
      title: extractTranslation('screening.case.review.case_review'),
      navigationOnFormComplete: 'screening-company-view',
      entityType: 'company',
    },
  },
];
